import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-sidebar-tip-info',
  templateUrl: './sidebar-tip-info.component.html',
  styleUrls: ['./sidebar-tip-info.component.css']
})
export class SidebarTipInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
